<canvas id="chartsAll">{{ chartInstance }}</canvas>
